import { Link, useLocation } from 'react-router';

export type CountChip = Readonly<{
  label: string;
  count: number | string;
  /** Opens the list filtered to exactly what the count counts. */
  to: string;
  tone?: 'warning' | 'danger';
}>;

export type CountChipsProps = Readonly<{
  ariaLabel: string;
  items: ReadonlyArray<CountChip>;
  /** Query keys that decide which chip is current; a chip is current when all of them match. */
  keys: ReadonlyArray<string>;
}>;

/**
 * Owner, 5 Oct 2026: counts sit in one compact row, sized like the Messages lanes,
 * and every count links to the list it counts.
 */
export function CountChips({ ariaLabel, items, keys }: CountChipsProps) {
  const location = useLocation();
  const current = new URLSearchParams(location.search);
  return <nav className="count-chips" aria-label={ariaLabel}>
    {items.map(item => {
      const target = new URL(item.to, 'https://staff.invalid');
      const active = target.pathname === location.pathname && keys.every(key => (current.get(key) ?? '') === (target.searchParams.get(key) ?? ''));
      const className = ['count-chips__chip', item.tone && Number(item.count) > 0 ? `count-chips__chip--${item.tone}` : '', active ? 'count-chips__chip--active' : ''].filter(Boolean).join(' ');
      return <Link key={item.label} className={className} to={item.to} aria-current={active ? 'page' : undefined}>
        <strong>{item.count}</strong><span>{item.label}</span>
      </Link>;
    })}
  </nav>;
}
